import React from "react";
import { useNavigate } from "react-router-dom";
import "./OrthoSection.scss";
import heart from "../../../Assets/heart.png";

export default function OrthoSection() {

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/Bid");   // 🔥 go to bid page
  };

  return (
    <div className="ortho-section">
      <div className="container-1440">

        {/* Heading */}
        <h1>
          Learn About <span>Orthopaedics & Spine</span>
        </h1>
        <p className="subtitle">
          Read the details below to understand more about Orthopaedics & Spine
          and to feel confident in choosing the right treatment options.
        </p>

        {/* Image */}
        <div className="top-img">
          <img src={heart} alt="ortho" />
        </div>

        <h3 className="what-title">What is Orthopaedics & Spine?</h3>
        <p className="desc">
          Orthopaedics & Spine focuses on the treatment of bones, joints, muscles,
          and the spine. It helps patients manage pain, injuries and movement
          problems using both non-surgical and surgical methods.
        </p>

        {/* Cards */}
        <div className="ortho_ortho_cards">

          <div className="ortho_card">
            <h4>Conditions Commonly Treated</h4>
            <ul>
              <li>Back and neck pain</li>
              <li>Slip disc and spine nerve compression</li>
              <li>Knee pain and joint problems</li>
              <li>Fractures and sports injuries</li>
              <li>Arthritis and joint stiffness</li>
              <li>Spine deformities and posture issues</li>
            </ul>
          </div>

          <div className="ortho_card active">
            <h4>Treatment Options</h4>
            <ul>
              <li>Physiotherapy and pain management</li>
              <li>Medication and lifestyle guidance</li>
              <li>Minimally invasive procedures</li>
              <li>Joint replacement surgery</li>
              <li>Spine surgeries</li>
            </ul>
          </div>

          <div className="ortho_card">
            <h4>Recovery & Care</h4>
            <ul>
              <li>Post surgery rehab</li>
              <li>Exercise & posture correction</li>
              <li>Regular follow-ups</li>
              <li>Pain control guidance</li>
            </ul>
          </div>

        </div>

        {/* BUTTON */}
        <button className="continue-btn" onClick={handleClick}>
          Continue to Set Budget
        </button>

      </div>
    </div>
  );
}
